import { EntityType } from '../enums/entity-enums.js';
import type { OwnerType } from '../enums/owner-enums.js';
import { IObject } from './hierarchy-entities.js';

export enum ArchiveQueryCondition {
  GT = 'gt',
  LT = 'lt',
  EQ = 'eq',
  GTE = 'gte',
  LTE = 'lte',
  NE = 'ne',
}

export interface ICondition {
  entityType: EntityType;
  entityPropertyName: string;
  condition: ArchiveQueryCondition;
  conditionValue?: string | number | null;
}

export enum QueryLogicalOperator {
  And = 'and',
  Or = 'or',
}

export interface IConditionGroup {
  operator: QueryLogicalOperator;
  conditions: ICondition[];
}

export interface IQueryResultConfig {
  hierarchy: string[];
  filters: { [key: string]: string };
}

export interface IQuery {
  queryid?: string;
  queryName: string;
  conditionGroups: IConditionGroup[];
  // Combines the results of conditionGroups; each group combines its own conditions with group.operator
  groupsOperator: QueryLogicalOperator;
  owner: string;
  ownerType: OwnerType;
  companyid: string;
  archiveid: string;
  groupBy: GroupByHierarchyLevelType | '';
  dataType: string[];
  resultConfig: IQueryResultConfig;
}

export interface IQueryResult {
  groupedDataType: Record<string, string[]>,
  data: ({ id: string, name: string, entityType: string, objects: { [key: string]: { name: string, id: string } }[] } | IObject)[];
  setFilters: (data: { [key: string]: string }) => void;
}

export type TQueryResultTable = Omit<IQueryResult, 'data'> & {
  data: {
    id: string;
    name: string;
    entityType: string;
    objects: Record<string, IObject>[]
  }[]
};

export enum GroupByHierarchyLevelType {
  Country = 'country',
  Field = 'field',
  Site = 'site',
  Well = 'well',
  Wellbore = 'wellbore',
}

export type DefaultQueryResult = Omit<IQueryResult, 'data'> & {
  data: {
    id: string;
    name: string;
    entityType: string;
    objects: { [k: string]: { id: string, name: string } }[];
  }[];
};

export type TDefaultResultTableProps = {
  archiveId: string | undefined,
  queryResult: DefaultQueryResult,
  resultConfig: IQueryResultConfig,
  setFilters: (data: { [key: string]: string }) => void,
};

export interface IQueryMongoSchema extends IQuery, Document {}